import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicComponent } from './public.component';
import { IndexComponent } from './index/index.component';
import { MobileloginComponent } from './mobilelogin/mobilelogin.component';
import { AdmissionopenComponent } from './admissionopen/admissionopen.component';
import { ApplicationComponent } from './application/application.component';
import { ApplicationstatusComponent } from './applicationstatus/applicationstatus.component';
import { ApplicationsuccessComponent } from './applicationsuccess/applicationsuccess.component';
import { PrintapplicationComponent } from './printapplication/printapplication.component';
const routes: Routes = [
  { 
    path: '', 
    component: PublicComponent,
    children: [
      { path: '', component:IndexComponent, pathMatch: 'full'},
      { path: 'login', component:LoginComponent, pathMatch: 'full'},
      { path: 'mobilelogin', component:MobileloginComponent, pathMatch: 'full'},
      { path: 'Public/admissionopen', component:AdmissionopenComponent, pathMatch: 'full'},
      { path: 'Public/application', component:ApplicationComponent, pathMatch: 'full'},
      { path: 'Public/applicationstatus', component:ApplicationstatusComponent, pathMatch: 'full'},
      { path: 'Public/applicationsuccess', component:ApplicationsuccessComponent, pathMatch: 'full'},
     
     
    ]
},
 {
    path: '', children: [      
      { path: 'Public/printapplication', component:PrintapplicationComponent, pathMatch: 'full'}
     
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule { }
